<template>
  <div class="front-dzsdetail">
    <div class="aimcontent">
      <div style=" text-align: left; margin: 0 auto; width: 1100px; padding-top: 10px">
        <span style="font-size: 16px">当前位置：</span>
        <span style="color: blue; font-size: 16px">首页 > 电子书 > 电子书详情 </span>
      </div>
      <div class="bookDetail">

        <div style="width: 150px; text-align: center; height: 616px">
          <img :src="bookInfo.coverUrl" width="219" height="311">
        </div>
        <div class="bookDetailRight1">
          <div class="bookDetailRightTitle1">
            {{bookInfo.title}}
          </div>
          <div class="bookDetailRightContent1">
            <div class="bookDetailRightContentItemDiv1">
              <span class="contentTitle">作者：</span><span class="bookDetailRightContentItem1">{{bookInfo.author}}</span>
            </div>
            <div class="bookDetailRightContentItemDiv1">
              <span class="contentTitle">出版社：</span><span class="bookDetailRightContentItem1">{{bookInfo.press}}</span>
            </div>
            <div class="bookDetailRightContentItemDiv1">
              <span class="contentTitle">出版时间：</span><span
              class="bookDetailRightContentItem1">{{bookInfo.publishTime}}</span>
            </div>
            <div class="bookDetailRightContentItemDiv1">
              <span class="contentTitle">所属分类：</span><span
              class="bookDetailRightContentItem1">{{bookInfo.typeName}}</span>
            </div>
            <div class="bookDetailRightContentItemDiv1">
              <span class="contentTitle">简介：</span>
              <div class="bookDetailRightIntroduce1">{{bookInfo.introduce}}</div>
            </div>
            <div style="text-align: right; ">

              <el-dropdown>
                <el-button type="primary" style="padding-right: 10px">
                  下载文件（{{bookInfo.pdfList.length}}个文件）<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown" >
                  <el-dropdown-item v-for="pdf in bookInfo.pdfList" @click.native="downLoadFile(pdf.location)" :key="pdf.id">{{pdf.name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <!--<el-button type="primary" style="max-width: 175px" icon="el-icon-download" v-for="pdf in bookInfo.pdfList" @click="downLoadFile(pdf.url,pdf.name)">
                {{pdf.name}}
              </el-button>-->
            </div>
          </div>
        </div>
      </div>
      <div style=" margin: 0 auto; width: 1140px;border-bottom:1px dashed #787878;text-align: left; margin-top: 50px">
        <span style="font-weight: bolder; color: #256EFF;">
          主题相关
        </span>
      </div>

      <div style="margin: 0 auto;display: flex; justify-content: space-between; width: 1100px; flex-wrap: wrap; height: 620px">
        <div v-for="item in sptjList_topic"
             class="bookList">
          <div style="display: flex; align-items: center; justify-content: space-around;">
            <img :src="item.coverUrl" :title="item.title" width="151" height="196">
          </div>
          <div style="margin-top: 15px; display: flex; flex-direction: column; text-align: left; line-height: 25px">
            <span style="font-weight: bolder; color: #3372EF; font-size: 16px; text-align: center">
                  {{item.title}}
            </span>
          </div>
        </div>
      </div>

      <div style=" margin: 0 auto; width: 1140px;border-bottom:1px dashed #787878;margin-top: 50px;text-align: left">
        <span style="font-weight: bolder; color: #256EFF;">
          作者相关
        </span>
      </div>

      <div style="margin: 0 auto;display: flex; justify-content: space-between; width: 1100px; flex-wrap: wrap; ">
        <div v-for="item in sptjList_author"
             class="bookList">
          <div style="display: flex; align-items: center; justify-content: space-around;">
            <img :src="item.coverUrl" :title="item.title" width="151" height="196">
          </div>
          <div style="margin-top: 15px; display: flex; flex-direction: column; text-align: center; line-height: 25px">
            <span style="font-weight: bolder; color: #3372EF; font-size: 16px">
                  {{item.title}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {qryEbookList, qryEbookInfoById,getDownloadUrl,authToken} from '../../request/api';

  export default {
    name: 'front',
    data() {
      return {
        bookId: this.$route.query.bookId,
        bookInfo: {
          id:"",
          coverUrl: "",
          title: "",
          introduce: "",
          keyWord: "",
          fileAddress: "",
          author: "",
          publishTime: '',
          press: '',
          typeName: '',
          typeId:'',
          downloadTimes: '',
          visitTimes: '',
          pdfList: {
            name: '',
            url: ''
          }
        },
        sptjList_author: [],
        sptjList_topic: [],
        authToken: authToken(),
        downLoadUrl: getDownloadUrl()
      }
    },
    methods: {
      logout() {
        localStorage.removeItem("token");
        // 管理员页面
        this.$router.push('/');
      },
      handleEdit() {
        this.dialogFormVisible = true;
        //this.form.userName = this.$route.params.userInfo.userName;

      },
      toSecondPage(routerUrl) {
        console.log("定位地址:" + routerUrl)
        this.$router.push(routerUrl);
      },
      qryEbookInfoById() {
        let param = {
          id: this.bookId
        }
        qryEbookInfoById(param).then(
          resp => {
            if (resp.code === 1) {
              // 渲染数据
              this.bookInfo = resp.data;
              // 加载图书列表
              this.loadEbookAuthorList();
              this.loadEbookTopicList();
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })
      },
      loadEbookTopicList() {
        let param = {
          nowPage: 1,
          pageSize: 10,
          typeId: this.bookInfo.typeId,
          unEqId: this.bookInfo.id
        }
        qryEbookList(param).then(
          resp => {
            if (resp.code === 1) {
              // 渲染数据
              this.sptjList_topic = resp.data.dataList;

            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })
      },
      loadEbookAuthorList() {

        let param = {
          nowPage: 1,
          pageSize: 5,
          author: this.bookInfo.author,
          unEqId: this.bookInfo.id
        }
        qryEbookList(param).then(
          resp => {
            if (resp.code === 1) {
              // 渲染数据
              this.sptjList_author = resp.data.dataList;

            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })
      },
      /**
       * 下载文件
       */
      downLoadFile(fileLocation) {
        let authToken = this.authToken
        let downLoadUrl = this.downLoadUrl;
        let location = fileLocation.replaceAll('\\','%2F');
        let completeUrl =  downLoadUrl+ '?Authorization=' + authToken + '&fileLocation=' + location;
        window.open(completeUrl ,'_self')
      },

    },
    mounted() {
      // 加载电子书详情
      this.qryEbookInfoById();

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .front-dzsdetail {
    width: 100%;
    min-width: 1500px;
    max-width: 1920px;
    height: auto;
    display: flex;
    flex-direction: column;
  }

  .top {
    width: 100%;
    height: 42px;
    background-image: url("../../assets/images/top_bg.png");
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .dialogClass {
    min-width: 720px;
  }

  .footer {
    width: 100%;
    height: 199px;
    background-image: url("../../assets/images/down_porfile_bg.png");
  }

  .tool-bar {
    height: 500px;
  }

  .tool-bar .el-carousel__container {
    height: 500px
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  .aimcontent {
    width: 100%;
    height: 1900px;
    background-image: url("../../assets/images/bg@2x.png");
  }

  .a {
    position: absolute;
  }

  .b {
    position: absolute;
  }

  .left-but:hover {
    .b {
      display: block
    }

    .a {
      display: none
    }
  }

  .c {
    position: absolute;
  }

  .d {
    position: absolute;
  }

  .right-but:hover {
    .d {
      display: block
    }

    .c {
      display: none
    }
  }

  .pageWord {
    margin: 0 auto;
    width: 1100px;
    margin-top: 20px;
    text-align: left;

  }

  .pageWord span {
    font-size: 18px;
    line-height: 25px;
    margin-left: 5px
  }

  li a:hover {
    color: #3372EF
  }

  .active {
    color: #3372EF;
  }

  .pageDiv {
    width: 1100px;
    margin: 0 auto;
    height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
    padding-left: 10px;
    padding-right: 10px;
  }

  .bookDetail {
    text-align: left;
    margin: 0 auto;
    width: 1100px;
    display: flex;
    justify-content: space-between;
    border: 1px dashed #787878;
    margin-top: 30px;
    padding: 20px
  }

  .bookDetailRight1 {
    text-align: center;
    width: 800px;
    height: 616px;
  }

  .bookDetailRightTitle1 {
    display: flex;
    justify-content: flex-start;
    font-weight: bolder;
    color: #1A1A1A;
    font-size: 20px;
  }

  .bookDetailRightContent1 {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background-image: url("../../assets/images/panel02.png");
    margin-top: 10px;
    border: 1px dashed #787878;
    margin-right: 30px;
    padding: 50px;
  }

  .bookDetailRightIntroduce1 {
    width: 580px;
    height: 220px;
    text-align: left
  }

  .bookDetailRightContentItemDiv1 {
    display: flex;
    justify-content: flex-start;
    line-height: 50px;
    margin-left: 50px;
  }

  .contentTitle {
    width: 80px;
    text-align: left;
  }

  .bookDetailRightContentItem1 {

    color: #4C88FF;
  }

  .bookList {
    width: 190px;
    height: 250px;
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    margin-top: 30px;
    padding: 15px;
  }

  .el-button--primary {
    max-width: none;
  }


</style>



// WEBPACK FOOTER //
// src/components/front/dzsdetail.vue